function Filter() {
  return (
    <svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M38.57 0H1.43C.639 0 0 .64 0 1.429V8.57c0 .406.172.792.473 1.063l13.813 12.431v16.506a1.429 1.429 0 002.067 1.278l8.571-4.285c.484-.242.79-.737.79-1.279v-12.22L39.527 9.637c.302-.272.474-.66.472-1.066V1.43C40 .639 39.36 0 38.572 0z"
        fill="#2C2C2C"
      />
    </svg>
  );
}

export default Filter;
